export default __webpack_public_path__ + "static/media/ihc_logo_colour.7e1a460e.svg";